module.exports = __webpack_public_path__ + "img/logo_big.774e56de.png";